<div class="ls-card" [ngStyle]="cardStyle()">
  @if (loading()) {
    <span
      class="spinner-border ls-card__spinner"
      role="status"
      aria-hidden="true"
      [ngStyle]="accentStyle()"
    ></span>
  } @else {
    <i
      class="bi ls-card__icon"
      [class]="'bi-' + icon()"
      [ngStyle]="accentStyle()"
    ></i>
  }

  <h3 class="ls-card__title" [ngStyle]="titleStyle()">{{ title() }}</h3>
  @if (text()) {
    <p class="ls-card__text" [ngStyle]="textStyle()">{{ text() }}</p>
  }

  @if (actionText(); as actionText) {
    <button
      type="button"
      class="lp-btn"
      [ngStyle]="buttonStyle()"
      (click)="action.emit()"
    >
      {{ actionText }}
    </button>
  }
</div>
